<template>
  <div>
  


    <div v-if="mapImg" class="mapdisplay-container">
      <img
        :src="mapImg"
        :key="mapImg"
        alt="Floor Map"
        class="map-image"
        @load="updateRatio"
        :draggable="false"
        id="dropZone"
      />
      <Itemcomponent
  :key="forceItemUpdate"
  :items="roundItemsForFloor"
  :areaWidthRatio="areaWidthRatio"
  :areaHeightRatio="areaHeightRatio"
  @openMenu="openMenu"
  :showgroupnumbers="showgroupnumbers"
  :showTooltip="true"
/>
    </div>

    <FlawModal
      v-if="flawModalVisable"
      :edit-flaw="selectedFlaw"
      @cancel="handleCloseFlawModal"
      @save="handleSaveFlaw"
      :show-map-button="false"
    />
  </div>
</template>


<script>
import Itemcomponent from './ItemComponent.vue';
import { mapActions, mapState } from 'vuex';
import FlawModal from '@/views/dashboard/FlawModal.vue';


export default {
	name: 'MapFloorView',
	components: {
		Itemcomponent,
		FlawModal
	},
	props: {
		floor: {
			type: Object,
			required: true
		},
		round: {
			type: Object,
			required: true
		},
	 showgroupnumbers: {
    type: Boolean,
    default: true	
  }
	},
	
	
	data() {
		return {
			mapImg: '',
			selectedMap: null,
			areaWidthRatio: 1,
			areaHeightRatio: 1,
			imgRatio: 1,
			flawModalVisable: false,  // Flytta hit
			selectedFlaw: null,
			forceItemUpdate: 0 ,// ✅ viktigt!,
		   
		};
	},
	computed: {
		...mapState('mapStore', ['maps']),

		roundItemsForFloor() {
			console.log('roundItemsForFloortest');
			if (!this.floor || !this.round || !this.round.roundHistoryInfos) return [];

			const info = this.round.roundHistoryInfos.find(
				(i) => i.floorName === this.floor.name
			);

			const items = info?.roundHistoryItems || [];

			// Returnera bara mapItem-objekten (och filtrera bort null)
			return items
				.map(i => i.mapItem)
				.filter(mapItem => !!mapItem); // skyddar mot null/undefined
		}
     
	},

	watch: {

		
	   showgroupnumbers: {
      handler(newValue) {
       console.log('test1',newValue)
      },
     
    },
   
		floor: {
			handler: 'fetchMapData',
			immediate: true
		},
		mapImg(newVal) {
			if (newVal) {
				this.$nextTick(() => {
					this.updateRatio();
				});
			}
		},
	
	},
	methods: {
		...mapActions('mapStore', ['getMaps', 'getMap', 'map']),
		...mapActions('fileStore', ['getFile']),

		openMenu(event, item) {
			try {
				if (
					item &&
      Array.isArray(item.flaws) &&
      item.flaws.length > 0 &&
      item.flaws[0] &&
      item.fireProtection &&
      item.fireProtection.name
				) {
					item.flaws[0].mapItemName = item.fireProtection.name;
					this.handleActionClick(item.flaws[0]);
				} else {
					console.warn('Önskade egenskaper saknas i item:', item);
					// Alternativt: hantera fallet när data inte finns
				}
			} catch (error) {
				console.error('Fel i openMenu:', error);
				// Valfritt: visa användarvänligt felmeddelande
			}
		},
  	handleActionClick(item) {
   
			this.selectedFlaw = item;
			this.flawModalVisable = true;
  
		},

		handleCloseFlawModal() {
			this.flawModalVisable = false;
			this.selectedFlaw = null;
		},

		async handleSaveFlaw(flaw) {
			this.handleCloseFlawModal();
			this.isPending = true;

			try {
				await this.$services.flaw.updateFlaw(flaw);

				this.$refs?.dashboardActions?.fetchData();
			} catch (error) {
				console.error(error.message);
			}

			this.isPending = false;
		},
		async fetchMapData() {
			if (!this.floor?.id) return;

			const t = this.round.roundHistoryInfos.find(
				(info) => info.floorName === this.floor?.name
			);

			console.log('t:', t);
			if (!t?.mapId) {
   
				return;
			}

			try {
				const res = await this.getMap(t.mapId);


				if (!res) {
					console.warn('Ingen kartdata returnerades.');
					return;
				}

				this.selectedMap = res;

				this.getFile(this.selectedMap.file.id).then((file) => {
					if (file instanceof Blob) {
						this.mapImg = URL.createObjectURL(file);
					} else if (typeof file === 'string') {
						this.mapImg = file;
					} else if (file?.url) {
						this.mapImg = file.url;
					}

					const img = new Image();
					img.onload = () => {
						this.imgRatio = img.height / img.width;
						this.updateRatio();
						this.forceItemUpdate = Date.now(); // trigger rerender om du vill
					};
					img.src = this.mapImg;
				});
			} catch (err) {
  
				this.mapImg = '';
			}
		},
		updateRatio() {
			const dropZone = document.getElementById('dropZone');
			if (dropZone) {
				this.areaWidthRatio = dropZone.offsetWidth / 1000;
				this.areaHeightRatio = dropZone.offsetHeight / 1000;
				console.log('Ratios:', this.areaWidthRatio, this.areaHeightRatio);
			}
		}
	},
	mounted() {
		window.addEventListener('resize', this.updateRatio);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.updateRatio);
	}
};
</script>

<style scoped>
.mapdisplay-container {
  position: relative;
  width: 100%;
  
}
.map-image {
  width: 100%;
}


.toggle-btn {
  background: #3a3a3a;        /* snygg röd bakgrund */
  color: #fff;                /* vit text */
  border: none;
  padding: 8px 14px;
  border-radius: 20px;        /* rundad */
  cursor: pointer;
  font-weight: 500;
  font-size: 12px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
  transition: background 0.2s, transform 0.1s;
}

.toggle-btn:hover {
  background: #6ed32f;
}

.toggle-btn:active {
  transform: scale(0.95);
}
</style>
